import { render } from "./KBDeX.vue?vue&type=template&id=ca9fb4f4"
import script from "./KBDeX.vue?vue&type=script&lang=js"
export * from "./KBDeX.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__